import { Route, Routes } from "react-router-dom";
import { Error404 } from 'pages';
import EquipmentSetting from "pages/management/setting/basic/equipment";
import EquipmentModifySetting from "pages/management/setting/basic/equipment-modify";

export default function MonitoringSettingEquipmentRoutes(props) {

    return (
        <Routes>
            <Route path="/*">
                <Route path="/*" element={ <EquipmentSetting /> }/>
                
                <Route path="add" element={ <EquipmentModifySetting /> }/>
                <Route path="modify/:id" element={ <EquipmentModifySetting /> }/>
               
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}